import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './index.less';

import { ApiKeyScopeRefType } from '../../../../gamma-api';
import ApiKeys, { ApiKeysMode } from '../../../components/ApiKeys';
import IbPageTitle from '../../../components/IbPageTitle';

import { MAIN_CLASS_NAME } from './const';

const ApiKeysPage: React.FC = () => {
  const { t } = useTranslation();

  const [mode, setMode] = useState(ApiKeysMode.Default);

  const onCreateApiKeyClick = () => {
    setMode(ApiKeysMode.Creation);
  };

  const onApiKeysModeToggle = (value: ApiKeysMode) => {
    setMode(value);
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      <IbPageTitle title={t('API-Key: List: Title')} onAdd={onCreateApiKeyClick} />
      <ApiKeys mode={mode} scopeRef={{ id: '', type: ApiKeyScopeRefType.Tenant }} onModeToggle={onApiKeysModeToggle} />
    </div>
  );
};

export default ApiKeysPage;
